// extracted by extract-css-chunks-webpack-plugin
module.exports = {"embed-container":"_3Vs4qg","embed":"_35mUO5","ready":"_2aLOIV"};